module.exports = __webpack_public_path__ + "static/media/pallavi_buwa.5aaf6fe4.jpg";